import isEqual from 'lodash/isEqual';
import { type GridColumnSizingState } from '@adv-frontend/grid';
import { tryParseJSON } from '@adv-frontend/yastore-modules/lib';
import { type GridSizesStorageKey, persistentStorage } from '../storage';

export const saveToStorageColumnSizing = (columnsSizing: GridColumnSizingState, storageKey: GridSizesStorageKey) => {
    const storageItem = tryParseJSON<Record<string, number>>(persistentStorage.getItem(storageKey));
    const isSizeEqualsToSavedStorageItem = isEqual(storageItem, columnsSizing);
    const save = () => persistentStorage.setItem(storageKey, JSON.stringify(columnsSizing));

    if (!storageItem) {
        save();

        return;
    }

    if (isSizeEqualsToSavedStorageItem) {
        return;
    }

    save();
};
